import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DatePicker, TimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

import {
    Box,
    Typography,
    TextField,
    Button,
    Paper,
    Grid,
    IconButton,
    InputAdornment,
    Card,
    Divider,
    MenuItem,
    Container,
    CardContent,
    Avatar,
    Chip
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { IoMdInformationCircleOutline } from "react-icons/io";
import { MdEmail } from "react-icons/md";
import { FaSquarePhone } from "react-icons/fa6";
import { FaCalendarAlt, FaClock } from "react-icons/fa";
import Cookies from 'js-cookie';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import AppBarComponent from '../../component/appbar';
import { addRoomBooking, ContractEmailRoom, ContractPDFRoom, getRoomBookingsByBetweenDate, getRoomBookingsByRoomBookigID, updateRoomBooking } from '../../service/room_service';
import { AlertError, AlertLoading, AlertSuccess } from '../../component/popupAlert';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import WbTwilightIcon from '@mui/icons-material/WbTwilight';
import WbSunnyIcon from '@mui/icons-material/WbSunny';

const DetailRoomView = () => {
    dayjs.extend(utc)
    dayjs.extend(timezone)
    const theme = useTheme();
    const navigate = useNavigate();
    const { id } = useParams();
    const location = useLocation();
    const pathname = location.pathname;
    const [createState, setCreateState] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [selectedDateCheckIn, setSelectedDateCheckIn] = useState(dayjs());
    const [selectedDateCheckOut, setSelectedDateCheckOut] = useState(dayjs());
    const [checkInTime, setCheckInTime] = useState(dayjs().set('hour', 0).set('minute', 0));
    const [checkOutTime, setCheckOutTime] = useState(dayjs().set('hour', 0).set('minute', 0));
    const token = Cookies.get('token');
    const [tempdata, setTempData] = useState([]);
    const [errorText, setErrorText] = useState(false);
    const [errorTextState, setErrorTextState] = useState(false);
    const [Price, setPrice] = useState(0.00)
    const initialBookingData = {
        first_name: '',
        last_name: '',
        email: '',
        tel: '',
        note: '',
        corking_fee: 0,
        other_service: 0,
        packageinfo: '',
        hour: 1,
        price: 0.00,
        other_service_price: 0
    };
    const [bookingData, setBookingData] = useState(initialBookingData);
    const [paymentState, setPaymentState] = useState(
        {
            credit: 0,
            cash: 0,
        }
    );

    useEffect(() => {
        const token = Cookies.get('token');
        if (!token) {
            navigate('/login');
        }

        if (pathname.includes('/create')) {
            setEditMode(false);
            setCreateState(true);
        }

        if (pathname.includes('/view')) {
            setEditMode(true);
            setCreateState(false);
            handleGetRoomBookingByRoomBookingID()
        }

    }, []);


    useEffect(() => {
        const checkAvailability = async () => {
            if (!bookingData.packageinfo) {
                return; // No package selected, skip further checks
            }

            // Determine hour based on the selected package
            const updatedHour =
                bookingData.packageinfo === 'รายชั่วโมง'
                    ? bookingData.hour
                    : bookingData.packageinfo === '4 ชั่วโมง'
                        ? 4
                        : bookingData.packageinfo === '8 ชั่วโมง'
                            ? 8
                            : 1;

            // Price calculation function to handle different packages
            const calculatePrice = (packageInfo, hour, corkingFee, otherService, otherServicePrice) => {
                let price = 0;

                if (packageInfo === "รายชั่วโมง") {
                    price = 3000 * hour;
                } else if (packageInfo === "4 ชั่วโมง") {
                    price = 10000;
                } else if (packageInfo === "8 ชั่วโมง") {
                    price = 18000;
                }

                // Add corking fee
                if (corkingFee === 1) {
                    price += 500;
                }

                // Add other service price if applicable
                // const otherServicePriceInt = parseInt(otherServicePrice, 10);
                // const priceInt = parseInt(price, 10);
                // if (otherService === 1 && !isNaN(otherServicePriceInt)) {
                //     priceInt += otherServicePriceInt;
                // }

                if (otherService === 1) {
                    const otherServicePriceInt = parseInt(bookingData.other_service_price, 10);
                    console.log('otherServicePriceInt', otherServicePriceInt);
                    console.log('otherServicePriceIsNull', isNaN(otherServicePriceInt));

                    price += isNaN(otherServicePriceInt) ? 0 : otherServicePriceInt;
                }

                return price;
            };

            // Calculate price based on the selected package and other factors
            const price = calculatePrice(
                bookingData.packageinfo,
                updatedHour,
                bookingData.corking_fee,
                bookingData.other_service,
                // bookingData.other_service_price
            );

            // Set the price state
            setPrice(price);

            // Calculate datetime for check-in and check-out
            const checkOutCalculatedTime = checkInTime.clone().add(updatedHour, 'hour');
            const datetimeCheckin = new Date(`${selectedDateCheckIn.format('YYYY-MM-DD')}T${checkInTime.format('HH:mm')}:00`);
            const datetimeCheckout = new Date(datetimeCheckin.getTime() + updatedHour * 60 * 60 * 1000);
            const formattedDateCheckOut = dayjs(datetimeCheckout).format('YYYY-MM-DD');

            const bookingPayload = {
                roombooking_id: bookingData.roombooking_id,
                datetimeCheckin,
                datetimeCheckout,
            };

            setSelectedDateCheckOut(dayjs(formattedDateCheckOut));
            setCheckOutTime(checkOutCalculatedTime);

            try {
                if (bookingData.packageinfo !== '') {
                    const res = await handleGetRoomBookingByBetweenDate(bookingPayload);

                    // Check if there are existing bookings in the selected time range
                    if (res.length > 0) {
                        setErrorTextState(true);
                        setErrorText('วันเวลาที่เลือกมีการจองอยู่ในช่วงเวลาที่กำหนด');
                        return;
                    } else {
                        setErrorTextState(false);
                        setErrorText('');
                    }
                }
            } catch (error) {
                console.error("Error fetching room booking data:", error);
                AlertError('เกิดข้อผิดพลาด', "ไม่สามารถตรวจสอบข้อมูลการจองได้ในขณะนี้");
            }
        };

        checkAvailability(); // Call the async function inside useEffect
    }, [
        selectedDateCheckIn,
        checkInTime,
        bookingData.packageinfo,
        bookingData.hour,
        bookingData.corking_fee,
        bookingData.other_service,
        // bookingData.other_service_price
    ]);

    const pricingOptions = [
        {
            icon: <AccessTimeIcon sx={{ fontSize: 40, color: '#1976d2' }} />,
            title: "รายชั่วโมง",
            price: "3,000",
            unit: "บาท/ชั่วโมง"
        },
        {
            icon: <WbTwilightIcon sx={{ fontSize: 40, color: '#f57c00' }} />, // เปลี่ยนสีเป็นสีเข้ม
            title: "4 ชั่วโมง",
            price: "10,000",
            unit: "บาท/4 ชั่วโมง"
        },
        {
            icon: <WbSunnyIcon sx={{ fontSize: 40, color: '#ed6c02' }} />,
            title: "8 ชั่วโมง",
            price: "18,000",
            unit: "บาท/8 ชั่วโมง"
        }
    ];

    const handleChange = (e) => {
        const { name, value } = e.target;

        // Update booking data
        setBookingData((prevData) => ({
            ...prevData,
            [name]: name === 'other_service_price' ? parseInt(value, 10) : value
        }));

        // Handle price update for 'other_service_price'
        if (name === 'other_service_price') {
            const otherServicePriceInt = parseInt(value, 10);
            setPrice((prevPrice) => prevPrice - (bookingData.other_service_price || 0) + otherServicePriceInt);
        }
    };


    const handleConfirm = async (e) => {
        e.preventDefault();
        AlertLoading();
        try {
            let data = bookingData
            data.status = 'เสร็จสิ้น'
            const res = await updateRoomBooking(id, data, token);
            AlertSuccess('เสร็จสิ้น', 'บันทึกข้อมูลสำเร็จ');
        } catch (error) {
            console.error("handleCancel", error)
            AlertError('เกิดข้อผิดพลาด', 'เกิดข้อผิดพลาดในการอัพเดทข้อมูล')
        }
        navigate('/thewonderblueadmin_room')
    };

    const handleToggleCondition = (event) => {
        const { name } = event.target;

        if (name !== "other_service") {
            setBookingData((prevData) => {
                const newValue = prevData[name] === 1 ? 0 : 1;

                // Adjust the price only if 'name' is 'corking_fee
                if (newValue === 1) {
                    setPrice(Price + 500)
                } else {
                    setPrice(Price - 500)
                }
                return {
                    ...prevData,
                    [name]: newValue,
                };
            });
        } else {
            setBookingData((prevData) => {
                const newValue = prevData[name] === 1 ? 0 : 1;
                if (newValue === 0) {
                    setPrice(Price - bookingData.other_service.price)
                    const newData = bookingData
                    newData.other_service_price = 0;
                    setBookingData(newData);
                }
                return {
                    ...prevData,
                    [name]: newValue,
                };
            });
        }
    };

    const handleChangePayment = (paymentMethod) => {
        setPaymentState((prevData) => {
            // สลับค่าของ paymentMethod ที่เลือก และรีเซ็ตตัวอื่นเป็น 0
            const updatedData = { credit: 0, cash: 0, nopay: 0 };
            updatedData[paymentMethod] = prevData[paymentMethod] === 1 ? 0 : 1;
            return updatedData;
        });
    };

    const resetForm = () => {
        setBookingData(initialBookingData);
        setSelectedDateCheckOut(dayjs());
        setSelectedDateCheckIn(dayjs());
        setCheckInTime(dayjs().set('hour', 0).set('minute', 0));
        setCheckOutTime(dayjs().set('hour', 0).set('minute', 0));
    };

    const handleSubmit = async () => {
        const requiredFields = ['first_name', 'last_name', 'email', 'tel'];
        const missingFields = requiredFields.filter(field => !bookingData[field]);

        if (missingFields.length > 0) {
            return AlertError('ข้อมูลไม่ครบถ้วน', 'กรุณากรอกข้อมูลให้ครบถ้วน');
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(bookingData.email)) {
            return AlertError('ข้อมูลไม่ถูกต้อง', 'รูปแบบอีเมลไม่ถูกต้อง');
        }

        if (bookingData.tel.length !== 10) {
            return AlertError('ข้อมูลไม่ถูกต้อง', 'เบอร์โทรศัพท์ต้องมี 10 หลัก');
        }

        bookingData.hour =
            bookingData.packageinfo === 'รายชั่วโมง'
                ? bookingData.hour
                : bookingData.packageinfo === '4 ชั่วโมง'
                    ? 4
                    : 8;

        if (!bookingData.hour || bookingData.hour <= 0) {
            return AlertError('ข้อมูลไม่ครบถ้วน', 'กรุณาระบุจำนวนชั่วโมงที่ต้องการจอง');
        }

        const checkOutCalculatedTime = checkInTime.clone().add(bookingData.hour, 'hour');
        const exDateTime = checkInTime.clone().add(60, 'day');
        const datetimeCheckin = new Date(`${selectedDateCheckIn.format('YYYY-MM-DD')}T${checkInTime.format('HH:mm')}:00`);
        const datetimeCheckout = new Date(datetimeCheckin.getTime() + bookingData.hour * 60 * 60 * 1000);

        // console.log('Check-in datetime:', datetimeCheckin);
        // console.log('Checkout datetime:', datetimeCheckout);

        const formattedDateCheckOut = dayjs(datetimeCheckout).format('DD-MM-YYYY');
        const formattedDateCheckIn = dayjs(datetimeCheckin).format('DD-MM-YYYY');


        if (bookingData.packageinfo === "รายชั่วโมง") {
            // bookingData.price = 3000 * bookingData.hour
            const price = 3000 * bookingData.hour
            setPrice(price)
        } else if (bookingData.packageinfo === "4 ชั่วโมง") {
            // bookingData.price = 10000
            setPrice(10000)
        } else if (bookingData.packageinfo === "8 ชั่วโมง") {
            // bookingData.price = 18000
            setPrice(18000)
        }



        let status
        if (paymentState.credit === 0 && paymentState.cash === 0) {
            status = "รอชำระเงิน"
        } else {
            status = "รอให้บริการ"
        }

        const bookingPayload = {
            ...bookingData,
            price: Price,
            datecheckin: formattedDateCheckIn,
            datecheckout: formattedDateCheckOut,
            check_in: checkInTime.format('HH:mm'),
            check_out: checkOutCalculatedTime.format('HH:mm'),
            datetimeCheckin,
            datetimeCheckout,
            cash: paymentState.cash,
            credit: paymentState.credit,
            ex_date: bookingData.ex_date === undefined ? exDateTime : bookingData.ex_date,
            status: status,
            other_service_price: bookingData.other_service === 0 ? 0 : bookingData.other_service_price
        };

        try {
            const existingBookings = await handleGetRoomBookingByBetweenDate(bookingPayload);
            if (existingBookings.length > 0) {
                return AlertError('เกิดข้อผิดพลาด', 'วันเวลาที่เลือกมีการจองอยู่ในช่วงเวลาที่กำหนด');
            }
        } catch (error) {
            console.error("Error fetching room booking data:", error);
            return AlertError('เกิดข้อผิดพลาด', 'ไม่สามารถตรวจสอบข้อมูลการจองได้ในขณะนี้');
        }

        try {
            if (createState) {
                await addRoomBooking(bookingPayload, token);
                // console.log('payload: ' , bookingPayload)
            } else {
                setEditMode(true);
                await updateRoomBooking(id, bookingPayload, token);
            }
            AlertSuccess('เสร็จสิ้น', 'บันทึกข้อมูลสำเร็จ');
            resetForm();
            navigate('/thewonderblueadmin_room');
        } catch (error) {
            console.error("Error saving room booking:", error);
            AlertError('เกิดข้อผิดพลาด', 'ไม่สามารถบันทึกข้อมูลได้');
        }
    };

    const handleGetRoomBookingByBetweenDate = async (data) => {
        try {
            const res = await getRoomBookingsByBetweenDate(data, token);
            // console.log(res);
            return res;
        } catch (error) {
            console.error("handleGetRoomBookingByDate", error);
        }
    };

    const handleGetRoomBookingByRoomBookingID = async () => {
        try {
            const res = await getRoomBookingsByRoomBookigID(id, token);
            // console.log("handleGetRoomBookingByRoomBookingID", res)
            setBookingData(res[0]);
            setCheckInTime(dayjs(res[0].check_in, "HH:mm"));
            setCheckOutTime(dayjs(res[0].check_out, "HH:mm"));
            setSelectedDateCheckIn(dayjs(res[0].datecheckin, "DD/MM/YYYY"))
            setSelectedDateCheckOut(dayjs(res[0].datecheckout, "DD/MM/YYYY"))
            setPaymentState({
                credit: res[0].credit,
                cash: res[0].cash,
                nopay: res[0].nopay,
            });

            setPrice(res[0].price)
        } catch (error) {
            console.error("handleGetRoomBookingByRoomBookingID", error);
            navigate('/404')
        }
    }

    const handleCancel = async () => {
        AlertLoading();
        try {
            let data = bookingData
            data.status = 'ยกเลิก'
            const res = await updateRoomBooking(id, data, token);
            AlertSuccess('เสร็จสิ้น', 'บันทึกข้อมูลสำเร็จ');
        } catch (error) {
            console.error("handleCancel", error)
            AlertError('เกิดข้อผิดพลาด', 'เกิดข้อผิดพลาดในการอัพเดทข้อมูล')
        }
        navigate('/thewonderblueadmin_room')
    }

    const handleEditMode = async () => {
        setEditMode(!editMode);
        if (editMode === false) {
            setBookingData(tempdata);
            setTempData([])
        } else {
            setTempData(bookingData);
        }
    };

    const ContractPDF = async () => {
        AlertLoading();
        try {
            const res = await ContractPDFRoom(bookingData, token);
            AlertSuccess('เสร็จสิ้น');
        } catch (error) {
            console.error("handleContractPDF", error)
            AlertError('เกิดข้อผิดพลาด', 'เกิดข้อผิดพลาดในการดาวน์โหลดเอกสารสัญญา')
        }
    };

    const ContractEmail = async () => {
        AlertLoading();
        try {
            const res = await ContractEmailRoom(bookingData, token);
            AlertSuccess('เสร็จสิ้น');
        } catch (error) {
            console.error("handleContractPDF", error)
            AlertError('เกิดข้อผิดพลาด', 'เกิดข้อผิดพลาดในการส่งอกสารสัญญา')
        }
    };

    const handleOnClickPackage = (selectedPackage) => {
        if (createState || !editMode) {
            let updatedPrice = 0;

            // คำนวณราคา based on แพ็คเกจที่เลือก
            if (selectedPackage === "รายชั่วโมง") {
                updatedPrice = 3000 * bookingData.hour;
            } else if (selectedPackage === "4 ชั่วโมง") {
                updatedPrice = 10000;
            } else if (selectedPackage === "8 ชั่วโมง") {
                updatedPrice = 18000;
            }

            const otherServicePriceInt = parseInt(bookingData.other_service_price, 10);
            console.log('otherServicePriceInt', otherServicePriceInt);
            console.log('otherServicePriceIsNull', isNaN(otherServicePriceInt));

            updatedPrice += isNaN(otherServicePriceInt) ? 0 : otherServicePriceInt;

            // อัปเดตข้อมูลการจองด้วยแพ็คเกจที่เลือกและราคาที่คำนวณ
            setBookingData((prevBookingData) => {
                const updatedBookingData = {
                    ...prevBookingData, // คัดลอกข้อมูลจาก state เดิม
                    packageinfo: selectedPackage, // อัปเดตแพ็คเกจที่เลือก
                };

                // Update the price state with the calculated price
                setPrice(updatedPrice);
                console.log("Updated Booking Data:", updatedBookingData);
                console.log("Updated Price:", updatedPrice);

                return updatedBookingData;
            });
        }
    };

    const PriceCard = ({ price, status }) => {
        return (
            <Card sx={{ padding: 2, margin: 5, boxShadow: 4, borderRadius: 4 }}>
                <CardContent>
                    {status !== undefined && (
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            <Box display="flex" alignItems="center">
                                <Typography variant="h5" color="text.primary" sx={{ marginLeft: 1 }}>
                                    สถานะ
                                </Typography>
                            </Box>
                            <Chip
                                label={status}
                                color={
                                    status === 'เสร็จสิ้น'
                                        ? 'success'
                                        : status === 'รอชำระเงิน'
                                            ? 'warning'
                                            : status === 'รอให้บริการ'
                                                ? 'info'
                                                : 'error'
                                }

                                sx={{ borderRadius: 1, width: '200px', fontSize: '20px' }}
                            />
                        </Box>
                    )}
                    <Box mt={2} display="flex" justifyContent="space-between" alignItems="center">
                        <Box display="flex" alignItems="center">
                            <Typography variant="h6" color="text.primary" sx={{ marginLeft: 1 }}>
                                ราคา
                            </Typography>
                        </Box>
                        <Typography variant="h5" color="text.secondary">
                            {price} บาท
                        </Typography>
                    </Box>
                </CardContent>
            </Card>
        );
    };


    const TimePickerField = ({ label, value, onChange, disabled }) => (
        <Grid item xs={12} sm={4}>
            <Typography sx={{ marginBottom: 2, fontSize: '18px' }}>{label}</Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <TimePicker
                    value={value}
                    onChange={onChange}
                    format="HH:mm"
                    ampm={false}
                    disabled={disabled} // Disable the TimePicker
                    slots={{
                        textField: (params) => (
                            <TextField
                                {...params}
                                fullWidth
                                required
                                disabled={disabled} // Disable the TextField
                                InputProps={{
                                    ...params.InputProps,
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <FaClock fontSize="24px" />
                                        </InputAdornment>
                                    ),
                                }}
                                InputLabelProps={{ shrink: true }}
                            />
                        ),
                    }}
                />
            </LocalizationProvider>
        </Grid>
    );


    const DatePickerField = ({ label, selectedDate, setSelectedDate, disable }) => (
        <Grid item xs={12} sm={4}>
            <Typography sx={{ marginBottom: 2, fontSize: '18px' }}>{label}</Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                    disablePast
                    value={selectedDate}
                    onChange={(newValue) => setSelectedDate(newValue)}
                    disabled={disable} // Use 'disabled' instead of 'disable'
                    format="DD/MM/YYYY"
                    slots={{
                        textField: (params) => (
                            <TextField
                                {...params}
                                fullWidth
                                required
                                disabled={disable} // Use 'disabled' instead of 'disable'
                                InputProps={{
                                    ...params.InputProps,
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <FaCalendarAlt fontSize="24px" />
                                        </InputAdornment>
                                    ),
                                }}
                                InputLabelProps={{ shrink: true }}
                            />
                        ),
                    }}
                />
            </LocalizationProvider>
        </Grid>
    );

    return (
        <Box>
            <AppBarComponent />
            <Box sx={{ display: 'flex', height: 'auto', bgcolor: 'white', margin: 1 }}>
                <Paper
                    elevation={3}
                    sx={{
                        m: 'auto',
                        width: '90%',
                        maxWidth: 2000,
                        height: '90%',
                        p: 3,
                        borderRadius: 4,
                        display: 'flex',
                    }}
                >
                    <Box sx={{ width: '25%', borderRight: '1px solid #e0e0e0', pr: 2 }}>
                        <Typography variant="h6" sx={{ mb: 2, color: '#1976d2', fontWeight: 'bold' }}>
                            {createState ? "สร้างรายการจอง" : `Ticket number: ${bookingData.roombooking_id}`}
                        </Typography>
                        <Divider sx={{ marginRight: 3 }} />
                        <Box>
                            {!createState && (
                                <Box>
                                    <Typography variant="body2" sx={{ mb: 1, fontWeight: 'bold', fontSize: '18px', marginTop: '8px' }}>
                                        Option
                                    </Typography>
                                    {
                                        bookingData.status !== 'ยกเลิก' && bookingData.status !== 'เสร็จสิ้น' && (
                                            <Button
                                                fullWidth
                                                variant="outlined"
                                                sx={{
                                                    mt: '12px',
                                                    width: '96%',
                                                    borderColor: editMode ? 'primary.main' : 'black',
                                                    color: editMode ? 'primary.main' : 'black',
                                                }}
                                                onClick={handleEditMode}
                                            >
                                                {editMode === true ? "แก้ไขข้อมูลลูกค้า" : "ปิดการแก้ไข"}
                                            </Button>
                                        )
                                    }

                                    {
                                        bookingData.status !== 'เสร็จสิ้น' && bookingData.status !== 'ยกเลิก' && bookingData.status !== 'รอชำระเงิน' && (
                                            <Button
                                                fullWidth
                                                variant="outlined"
                                                sx={{
                                                    mt: '12px',
                                                    width: '96%',
                                                    borderColor: 'primary.main',
                                                    color: 'primary.main',
                                                }}
                                                onClick={handleConfirm}
                                            >
                                                ยืนยันการใช้งาน
                                            </Button>
                                        )
                                    }

                                    {
                                        bookingData.status !== 'เสร็จสิ้น' && bookingData.status !== 'ยกเลิก' && (
                                            <Button
                                                fullWidth
                                                variant="outlined"
                                                sx={{
                                                    mt: '12px',
                                                    width: '96%',
                                                    borderColor: 'primary.main',
                                                    color: 'primary.main',
                                                }}
                                                onClick={handleCancel}
                                            >
                                                ยกเลิก
                                            </Button>
                                        )
                                    }

                                    <Button
                                        fullWidth
                                        variant="outlined"
                                        sx={{
                                            mt: '12px',
                                            width: '96%',
                                            borderColor: 'primary.main',
                                            color: 'primary.main',
                                        }}
                                        onClick={ContractPDF}
                                    >
                                        โหลดใบสัญญา
                                    </Button>

                                    <Button
                                        fullWidth
                                        variant="outlined"
                                        sx={{
                                            mt: '12px',
                                            width: '96%',
                                            borderColor: 'primary.main',
                                            color: 'primary.main',
                                        }}
                                        onClick={ContractEmail}
                                    >
                                        ส่งใบสัญญาผ่าน Email
                                    </Button>
                                </Box>
                            )}
                        </Box>
                    </Box>
                    <Box sx={{ flexGrow: 1 , width: '75%', overflowY: 'auto', maxHeight: 'calc(100vh - 100px)'  }}>
                        <Container>
                            <Box
                                sx={{
                                    display: 'flex',
                                    gap: 2,
                                    flexDirection: { xs: 'column', md: 'row' },
                                    alignItems: 'stretch',
                                }}
                            >
                                {pricingOptions.map((option, index) => (
                                    <Card
                                        key={index}
                                        sx={{
                                            flex: 1,
                                            minWidth: 250,
                                            transition: '0.3s',
                                            border: bookingData.packageinfo === option.title ? '2px solid blue' : 'none',
                                            '&:hover': {
                                                boxShadow: 6,
                                            },
                                        }}

                                        onClick={() => handleOnClickPackage(option.title)}
                                    >
                                        <CardContent>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center',
                                                    gap: 2,
                                                }}
                                            >
                                                <Avatar
                                                    sx={{
                                                        p: 1,
                                                        bgcolor: 'grey.100',
                                                    }}
                                                >
                                                    {option.icon}
                                                </Avatar>

                                                <Typography variant="h5" component="h3" sx={{ fontWeight: 'bold' }}>
                                                    {option.title}
                                                </Typography>

                                                <Box sx={{ textAlign: 'center' }}>
                                                    <Typography variant="h4" component="p" sx={{ color: 'primary.main', fontWeight: 'bold' }}>
                                                        ฿{option.price}
                                                    </Typography>
                                                    <Typography color="text.secondary">
                                                        {option.unit}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        </CardContent>
                                    </Card>
                                ))}
                            </Box>
                        </Container>
                        <Card
                            sx={{
                                padding: 2,
                                margin: 5,
                                boxShadow: 4,
                                borderRadius: 4,
                                pointerEvents: editMode ? "none" : "auto", // Disable interaction
                                opacity: editMode ? 0.8 : 1, // Add visual feedback
                            }}
                        >
                            <Typography variant="h5" sx={{ mb: 2 }}>
                                ข้อมูลการจอง
                                <IconButton size="small">
                                    <IoMdInformationCircleOutline />
                                </IconButton>
                            </Typography>

                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={4}>
                                    <Typography sx={{ marginBottom: 1, fontSize: "18px" }}>แพ็กเกจ</Typography>
                                    <TextField
                                        select
                                        name="packageinfo"
                                        label="แพ็กเกจ"
                                        value={bookingData.packageinfo}
                                        onChange={handleChange}
                                        sx={{ marginBottom: 1 }}
                                        InputLabelProps={{ shrink: true }}
                                        fullWidth
                                    >
                                        <MenuItem value="รายชั่วโมง">รายชั่วโมง (1 ชั่วโมง)</MenuItem>
                                        <MenuItem value="4 ชั่วโมง">ครึ่งวัน (4 ชั่วโมง)</MenuItem>
                                        <MenuItem value="8 ชั่วโมง">เต็มวัน (8 ชั่วโมง)</MenuItem>
                                    </TextField>
                                </Grid>

                                {
                                    bookingData.packageinfo === 'รายชั่วโมง' && (
                                        <Grid item xs={12} sm={4}>
                                            <Typography sx={{ marginBottom: 1, fontSize: '18px' }}>จำนวนชั่วโมง</Typography>
                                            <TextField
                                                fullWidth
                                                name="hour"
                                                label="จำนวนชั่วโมง"
                                                required
                                                value={bookingData.hour}
                                                onChange={(e) => {
                                                    const value = Math.max(0, Math.min(12, Number(e.target.value)));
                                                    handleChange({ target: { name: 'hour', value } });
                                                }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                inputProps={{
                                                    min: 1,
                                                    max: 12,
                                                }}
                                                type="number"
                                            />
                                        </Grid>
                                    )
                                }
                            </Grid>

                            <Grid container spacing={2}>
                                <DatePickerField label="เลือกวันที่ Check In" selectedDate={selectedDateCheckIn} setSelectedDate={setSelectedDateCheckIn} />

                                <TimePickerField
                                    label="เวลาเช็คอิน"
                                    value={checkInTime}
                                    onChange={(newValue) => setCheckInTime(newValue)}
                                    disabled={editMode}
                                />
                            </Grid>

                            <Grid container spacing={2}>
                                <DatePickerField label="เลือกวันที่ Check Out" selectedDate={selectedDateCheckOut} setSelectedDate={setSelectedDateCheckOut} disable={true} />

                                <TimePickerField
                                    label="เวลาเช็คเอาส์"
                                    value={checkOutTime}
                                    onChange={(newValue) => setCheckOutTime(newValue)}
                                    disabled={true}
                                />
                            </Grid>

                            {
                                errorTextState && (
                                    <Typography sx={{ color: 'red', fontSize: '16px', marginTop: '8px' }} > ** {errorText} **</Typography>
                                )
                            }
                        </Card>

                        <Card sx={{ padding: 2, margin: 5, boxShadow: 4, borderRadius: 4 }}>
                            <Typography variant="h5" sx={{ mb: 2 }}>
                                บริการอื่นๆ
                                <IconButton size="small">
                                    <IoMdInformationCircleOutline />
                                </IconButton>
                            </Typography>
                            <FormGroup>
                                <FormControlLabel
                                    name="corking_fee"
                                    checked={bookingData.corking_fee === 1}
                                    onChange={handleToggleCondition}
                                    control={<Checkbox />}
                                    label="ค่าเปิดขวด 500 บาท"
                                    disabled={editMode}
                                />
                                <Box>
                                    <FormControlLabel
                                        name="other_service"
                                        checked={bookingData.other_service === 1}
                                        onChange={handleToggleCondition}
                                        control={<Checkbox />}
                                        label="อื่นๆ"
                                        disabled={editMode}
                                    />
                                    {
                                        bookingData.other_service === 1 && (
                                            <Grid container spacing={2} sx={{ mt: 0 }}>
                                                <Grid item xs={12} sm={4}>
                                                    <Typography sx={{ marginBottom: 1, fontSize: '18px' }}>ค่าบริการอื่นๆ</Typography>
                                                    <TextField
                                                        fullWidth
                                                        name="other_service_price"
                                                        label="ค่าบริการอื่นๆ"
                                                        required
                                                        value={bookingData.other_service_price}
                                                        onChange={(e) => {
                                                            const value = Math.max(0, Number(e.target.value)); // Ensure value is not less than 0
                                                            handleChange({ target: { name: e.target.name, value } });
                                                        }}
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        type="number"
                                                        disabled={editMode}
                                                    />
                                                </Grid>
                                            </Grid>
                                        )
                                    }
                                </Box>
                            </FormGroup>
                        </Card>
                        <PriceCard price={Price} status={bookingData.status} />

                        <Card sx={{ padding: 2, margin: 5, boxShadow: 4, borderRadius: 4 }}>
                            <Typography variant="h5" sx={{ mb: 2 }}>
                                ข้อมูลลูกค้า
                                <IconButton size="small">
                                    <IoMdInformationCircleOutline />
                                </IconButton>
                            </Typography>

                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={4}>
                                    <Typography sx={{ marginBottom: 2, fontSize: '18px' }}>ชื่อจริง</Typography>
                                    <TextField
                                        fullWidth
                                        name="first_name"
                                        label="ชื่อจริง"
                                        required
                                        value={bookingData.first_name}
                                        onChange={handleChange}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        disabled={editMode}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <Typography sx={{ marginBottom: 2, fontSize: '18px' }}>นามสกุล</Typography>
                                    <TextField
                                        fullWidth
                                        name="last_name"
                                        label="นามสกุล"
                                        required
                                        value={bookingData.last_name}
                                        onChange={handleChange}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        disabled={editMode}
                                    />
                                </Grid>
                            </Grid>

                            <Grid container spacing={2} sx={{ mt: 0 }}>
                                <Grid item xs={12} sm={4}>
                                    <Typography sx={{ marginBottom: 2, fontSize: '18px' }}>Email</Typography>
                                    <TextField
                                        fullWidth
                                        name="email"
                                        label="อีเมล"
                                        required
                                        placeholder="Email"
                                        value={bookingData.email}
                                        onChange={handleChange}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        disabled={editMode}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <MdEmail fontSize={'24px'} />
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <Typography sx={{ marginBottom: 2, fontSize: '18px' }}>Phone</Typography>
                                    <TextField
                                        fullWidth
                                        name="tel"
                                        label="เบอร์โทร"
                                        required
                                        placeholder="Phone"
                                        value={bookingData.tel}
                                        onChange={(e) => {
                                            const newValue = e.target.value.replace(/[^0-9]/g, ''); // Allows only numbers
                                            handleChange({ target: { name: 'tel', value: newValue } });
                                        }}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        disabled={editMode}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <FaSquarePhone fontSize={'24px'} />
                                                </InputAdornment>
                                            ),
                                            maxLength: 10
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Card>

                        <Card sx={{ padding: 2, margin: 5, boxShadow: 4, borderRadius: 4 }}>
                            <Typography variant="h5" sx={{ mb: 2 }}>
                                ช่องทางการชำระเงิน
                                <IconButton size="small">
                                    <IoMdInformationCircleOutline />
                                </IconButton>
                            </Typography>
                            <FormGroup>
                                <FormControlLabel
                                    name="cash"
                                    checked={paymentState.cash === 1}
                                    onChange={() => handleChangePayment('cash')}
                                    control={<Checkbox />}
                                    label="โอนเงิน"
                                    disabled={editMode}
                                />
                                <FormControlLabel
                                    name="credi"
                                    checked={paymentState.credit === 1}
                                    onChange={() => handleChangePayment('credit')}
                                    control={<Checkbox />}
                                    label="บัตรเคดิต"
                                    disabled={editMode}
                                />
                            </FormGroup>
                        </Card>

                        <Card sx={{ padding: 2, margin: 5, boxShadow: 4, borderRadius: 4 }}>
                            <Typography variant="h5" sx={{ mb: 2 }}>
                                หมายเหตุ
                                <IconButton size="small">
                                    <IoMdInformationCircleOutline />
                                </IconButton>
                            </Typography>
                            <TextField
                                fullWidth
                                name="note"
                                label="หมายเหตุ"
                                value={bookingData.note || ''}
                                onChange={handleChange}
                                multiline
                                disabled={editMode}
                                minRows={4}
                                InputLabelProps={{ shrink: true }}
                            />
                        </Card>

                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 4 }}>
                            <Button
                                variant="outlined"
                                sx={{ margin: 1, width: '200px' }}
                                onClick={() => navigate('/thewonderblueadmin_room')}
                            >
                                ย้อนกลับ
                            </Button>
                            {!editMode && (
                                <Button
                                    variant="contained"
                                    sx={{ margin: 1, width: '200px' }}
                                    onClick={handleSubmit}
                                >
                                    บันทึก
                                </Button>
                            )}
                        </Box>
                    </Box>
                </Paper>
            </Box>
        </Box>
    );
};

export default DetailRoomView;